import defaultComparator from './default';
import dateComparator from './date';
import selectComparator from './select';
import numericComparator from './numeric';

export default {
  default: defaultComparator,
  date: dateComparator,
  select: selectComparator,
  numeric: numericComparator,
};
